<template>
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{paddingTop: 0, paddingBottom: '16px' }">
		<template #title>
			<h6 class="font-semibold m-0">{{ $t('appointment-review-page.request-list-title')}}</h6>
		</template>
		<a-row :gutter="[24, 24]" class="review-appointment-list" style="margin-bottom: 15px; min-height: 600px; max-height: 600px; overflow-y: scroll !important">
            <review-appointment-card 
                v-for="(item, i) in appointments" 
                :key="i" 
                :item="item" 
                :selected="selectedId == item.id"
                @select="onSelected"
                @rejected="onRejected"
            />
                <!-- :approved="approved" -->
                <!-- @click.prevent="$refs.appointmentTimeLineModal.showModal()" -->
		</a-row>
        <div
            :style="{ textAlign: 'center', marginTop: '12px', height: '32px', lineHeight: '32px' }">
                <a-spin v-if="hasMoreData && isLoadingMore" />
                <a-button v-if="hasMoreData  && !isLoadingMore" type="primary" block size="small" @click="loadMore"> 
                    <svg v-show="true" width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 3C2.44772 3 2 3.44772 2 4C2 4.55228 2.44772 5 3 5H14C14.5523 5 15 4.55228 15 4C15 3.44772 14.5523 3 14 3H3Z" fill="#111827"/>
                        <path d="M3 7C2.44772 7 2 7.44772 2 8C2 8.55228 2.44772 9 3 9H10C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7H3Z" fill="#111827"/>
                        <path d="M3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H7C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11H3Z" fill="#111827"/>
                        <path d="M15 8C15 7.44772 14.5523 7 14 7C13.4477 7 13 7.44771 13 8L13 13.5858L11.7071 12.2929C11.3166 11.9024 10.6834 11.9024 10.2929 12.2929C9.90237 12.6834 9.90237 13.3166 10.2929 13.7071L13.2929 16.7071C13.4804 16.8946 13.7348 17 14 17C14.2652 17 14.5196 16.8946 14.7071 16.7071L17.7071 13.7071C18.0976 13.3166 18.0976 12.6834 17.7071 12.2929C17.3166 11.9024 16.6834 11.9024 16.2929 12.2929L15 13.5858L15 8Z" fill="#111827"/>
                    </svg>
			        {{ $t('navigation-actions.load-more') }}
		        </a-button>
                <div v-if="!hasMoreData" class="text-primary" style="font-weight: 600;">
                    {{ $t('state-messages.appointment-review-list.no-more-data')}}
                </div>
        </div>

        <div class="c_appointment_timeline_modal">
            <appointment-time-line-modal 
                ref="appointmentTimeLineModal"
                @approved="(e) => approved(e)" 
                @rescheduled="(e) => rescheduled(e)" 
            />
        </div>
	</a-card>

</template>

<script>
import AppointmentTimeLineModal from "./modals/AppointmentTimeLineModal.vue";
import { appointmentsClient, host } from '../../../api/config';

import { useAppointmentsStore } from '../../../stores/appointments-store';
import { mapActions,mapState } from 'pinia';
import { useAuthStore } from '../../../stores/auth-store.js';

import ReviewAppointmentCard from './ReviewAppointmentCard.vue';
export default ({
    components: {
        AppointmentTimeLineModal,
        ReviewAppointmentCard
    },
    data() {
        return {
            page: 1,
            size: 20,
            appointments: [],
            selectedId: '',
            hasMoreData: false,
            isLoadingMore: false,
            nextPageToken: '',
        }
    },
    computed: {
        ...mapState(useAuthStore, [ 'currentUser' ]),
        ...mapState(useAuthStore, [ 'profile' ]),

        isOfficial() {
            return (this.currentUser && this.currentUser.roles && this.currentUser.roles.includes('OFFICIAL'))
        },
    },
    methods: {
        ...mapActions(useAppointmentsStore, [ 'selectAppointment', 'clearSelection' ]),
        onSelected(e) {
            this.$refs.appointmentTimeLineModal.showModal();
            this.selectedId = e.id; 
            this.selectAppointment(e);
        },
        onRejected(e) {
            this.clearSelection();
            this.appointments = this.appointments.filter(apt => apt.id != e);
        },
        approved(e) {
            this.clearSelection();
            this.appointments = this.appointments.filter(apt => apt.id != e);
        },
        rescheduled(e) {
            // this.clearSelection();
            // this.appointments = this.appointments.filter(apt => apt.id != e);
        },
        fetch() {
            
            if (this.appointments.length > 0) {
                this.isLoadingMore = true;
                this.page++;
            } else {               
                for (let i = 0; i < 20; i++) {
                    this.appointments.push({ isLoading: true })
                }
            }

            let searchRequest = {
                textParams: [
                    {
                        "field": "status",
                        "value": "APPLIED",
                        "matchType": "EXACT"
                    }
                ],
                sortParams: [
                    {
                        "field": "dateCreated",
                        "type": "DESCENDING"
                    }
                ],
                page: this.page,
                size: this.size
            };
            if (this.isOfficial){
                searchRequest.textParams.push({
                        "field": "officialId",
                        "value": this.profile.id,
                        "matchType": "EXACT"
                    })
            }
            appointmentsClient.search(searchRequest).then(res => {
                if (!res.networkError && res.status == 200 && res.body && res.body.list) {
                    if (res.body.nextPageToken.length > 0) {
                        this.hasMoreData = true;
                    } else {
                        this.hasMoreData = false;
                    }
                    this.nextPageToken = res.body.nextPageToken;
                    this.isLoadingMore = false;
                    // this.isLoading = false;
                    res.body.list.forEach(apt => {
                        if (apt.visitor) {
                            if (apt.visitor.imageUrl == "") 
                                apt.visitor.imageUrl = 'images/default-avatar.jpg';
                            else
                                apt.visitor.imageUrl = host + apt.visitor.imageUrl;
                        }
                        if (apt.official) {
                            if (apt.official.imageUrl == "") 
                                apt.official.imageUrl = 'images/default-avatar.jpg';
                            else
                                apt.official.imageUrl = host + apt.official.imageUrl;
                        }
                    });
                    this.appointments = this.appointments.filter(apt => !apt.isLoading).concat(res.body.list);
                } else {
                    this.isLoadingMore = false;
                    // this.isLoading = false;
                    /* TODO: replace with data */
                }
                    
            });
        },
        loadMore() {
            this.fetch();
        }
    },

    mounted() {
        this.fetch();
    }
})

</script>

<style lang="scss">
// @media screen and (min-width: 992px) {
// 	.c_appointment_timeline{
// 		display: block;
// 	}
// 	.c_appointment_timeline_modal{
// 		display: none !important;
// 	}
// }
// @media screen and (max-width: 991px) {
// 	.c_appointment_timeline{
// 		display: none;
// 	}
// 	.c_appointment_timeline_modal{
// 		display: block;
// 	}
// }
</style>